import React from "react"

const About = () => {
  return (
    <section className="about-section text-center" id="about">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 mx-auto">
            <h2 className="text-white mb-4">Background</h2>
            <p className="text-white mb-3">
              Roads, railways and other construction projects can have a major impact on wildlife. This impact takes
              many forms and includes noise pollution, habitat destruction, fragmentation of species, disruption of
              natural movement, foraging and migration patterns and road accidents and death. Staffordshire County
              Council suggests that there are 150 deer injured and killed in road accidents every year just in the
              Cannock Chase area.</p>

            <p className="text-white mb-3">
              Until relatively recently our impact on wildlife was seen as a necessary consequence of our progress
              towards faster transport systems and economic advance. However there are improvements which can be made to
              lessen our impact on nature. These range from green bridges and wildlife tunnels to fencing and accident
              prevention. There have been some interesting developments recently. In June 2020 the Daily Telegraph
              reported that £8.5 million had been spent in two years on wildlife passageways. The Knutsford – Bowden
              bypass features a £1.15 green wildlife bridge. In Kent the A21 features a green bridge at Scotney Castle.
              In London there is a 25 m wide green bridge at Mile End. These represent a few showcase projects, but they
              are far from the norm. Natural England and Highways England have transport specialist and ecological
              advisors that play a role on some new developments, but this is not enough. Safe Passage For Wildlife
              Campaign believe that there should be a shift in emphasis to make all developers, for a wide range of
              projects, responsible for identifying their impact on wildlife and building in appropriate measures to
              lessen this impact, as a required part of the planning process. Landowners should have responsibilities
              with regard to appropriate fencing when, for example, a badger set, near to a road results in repeated
              injuries and fatalities. Responsibility for assessing and reducing our impact on wildlife should be the
              norm and not the exception.
            </p>

            <p className="text-white">
              Other countries are significantly more advanced in this regard than the UK. Both Canada and the USA can
              point to major projects to protect wildlife. In Europe France built the first green bridges in the 1950s
              but it is Holland which leads the way now with more than 47 ecoducts.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default About
